import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useMutation } from '@grandvisionhq/graphql';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useDispatchTrackEvent } from '@grandvisionhq/svc-tealium/events';
import { isNil } from '@grandvisionhq/utils';
import '@swc/helpers';
import { mapLineItemToDataLayerEvent } from '../mappers/analytics/data-layer/line-item-to-data-layer-event.js';
import '@grandvisionhq/payments';
import { mapRemovedProductToTealiumProduct } from '../mappers/analytics/tealium/line-item-to-tealium-product.js';
import '../operations/fragments/cart-details.js';
import '../operations/fragments/cart-validation-errors.js';
import '../operations/fragments/recover-inactive-cart-failure.js';
import '../operations/fragments/recover-inactive-cart-result.js';
import '../operations/mutations/add-cart-line-items.js';
import '../operations/mutations/add-cart-voucher-codes.js';
import '../operations/mutations/create-cart.js';
import '../operations/mutations/remove-cart-voucher-codes.js';
import { REMOVE_CART_LINE_ITEMS } from '../operations/mutations/remove-cart-line-items.js';
import '../operations/mutations/update-cart-line-items.js';
import '../operations/mutations/replace-line-item-contact-lenses-bundle-benelux.js';
import '../operations/mutations/recover-inactive-cart.js';
import '../operations/queries/get-cart.js';
import '../operations/queries/get-total-line-items.js';
import '../operations/queries/get-cart-estimated-delivery.js';

const useRemoveFromCart = (lineItem, onSuccess)=>{
    const [{ cartId  }, { setCartCount  }] = useCartStorage();
    const dispatchTrackEvent = useDispatchTrackEvent();
    const [removeCartItems, removeCartLineItemsMutation] = useMutation(REMOVE_CART_LINE_ITEMS, {
        onCompleted: (response)=>{
            if ('removeCartLineItems' in response) {
                const { success , cart  } = response.removeCartLineItems;
                success && cart && setCartCount(cart.numberOfItems);
            }
            const dataLayerEvents = mapLineItemToDataLayerEvent(DataLayer.DataLayerTypes.EventType.remove, [
                lineItem
            ], cartId || '');
            dataLayerEvents && DataLayer.pushEcommerceEvent(dataLayerEvents);
            const tealiumProduct = mapRemovedProductToTealiumProduct(lineItem);
            dispatchTrackEvent(()=>Promise.resolve({
                    id: 'Event',
                    Events_CartRemove: '1',
                    Products: tealiumProduct
                })
            );
            onSuccess && onSuccess();
        }
    });
    const removeFromCart = React.useCallback(()=>{
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItem.id
                        }, 
                    ]
                }
            },
            refetchQueries: [
                'GetCart'
            ]
        });
    }, [
        cartId,
        lineItem.id,
        removeCartItems
    ]);
    const { called , loading , error  } = removeCartLineItemsMutation;
    return [
        removeFromCart,
        {
            called,
            loading,
            error
        }
    ];
};

export { useRemoveFromCart };
//# sourceMappingURL=use-remove-from-cart.js.map
